export const MenuList = [
    // Dashboard
    {   
        title: 'Dashboard',
        iconStyle: <i className="fas fa-home" />,
        to: '/app/dashboard',
        // rights: ['TaskManagementSystemAccess'],
    },
    // Tasks
    {   
        title: 'Tasks',
        iconStyle: <i className="fas fa-list" />,
        to: '/app/tasks',
        rights: ['TaskManagementSystemAccess'],
    },
    // My Tasks
    {   
        title: 'My Tasks',
        iconStyle: <i className="fas fa-tasks" />,
        to: '/app/my-tasks',
        // rights: ['TaskManagementSystemAccess'],
    },
    // My Team Tasks
    {   
        title: 'My Campus Tasks',
        iconStyle: <i className="fas fa-users" />,
        to: '/app/team-tasks',
        rights: ['CampusLeader'],
    },
    // Calendar
    {   
        title: 'Calendar',
        iconStyle: <i className="fas fa-calendar" />,
        to: '/app/calendar',
        // rights: ['TaskManagementSystemAccess'],
    },
    // Monitoring
    {
        title: 'Monitoring',
        iconStyle: <i className="fas fa-chart-line" />,
        to: '/app/monitoring',
        rights: ['TaskManagementAdmin'],
    },
    // Notifications
    {   
        title: 'Notifications',
        iconStyle: <i className="fas fa-bell" />,
        to: '/app/notifications',
        rights: ['TaskManagementSystemAccess'],
    },
    // Reports
    {   
        title: 'Reports',
        iconStyle: <i className="fas fa-newspaper" />,
        to: '/app/reports',
        rights: ['TaskManagementAdmin'],
    },
    // Profile
    {   
        title: 'Profile',
        iconStyle: <i className="fas fa-user" />,
        to: '/app/profile',
        rights: ['TaskManagementSystemAccess'],
    },
    // Departments
    {   
        title: 'Departments',
        iconStyle: <i className="fas fa-building" />,
        to: '/app/departments',
        rights: ['TaskManagementAdmin'],
    },
    // Departments
    {   
        title: 'Lookups',
        iconStyle: <i className="fas fa-bars" />,
        to: '/app/lookups',
        rights: ['TaskManagementAdmin'],
    },
    // // Lookups
    // {
    //     title: 'Lookups',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i className="fas fa-bars" />,
    //     rights: ['TaskManagementAdmin'],
    //     content: [
    //       {
    //         title: 'Task Status',
    //         to: '/app/lookups/task-status',
    //         rights: ['TaskManagementAdmin'],
    //       },
    //       {
    //         title: 'Email Template',
    //         to: '/app/lookups/email-template',
    //         rights: ['TaskManagementAdmin'],
    //       },
    //       {
    //         title: 'SMS Template',
    //         to: '/app/lookups/sms-template',
    //         rights: ['TaskManagementAdmin'],
    //       },
    //     ],
    //   },
    // Settings
    {   
        title: 'Settings',
        iconStyle: <i className="fas fa-cog" />,
        to: '/app/settings',
        rights: ['TaskManagementSystemAccess'],
    },
];
